import React from 'react'
import "./ProfileUrl.css"
import LogoMark from "../../../images/LogoMark.png"
import Flag from "../../../images/Flag.png"

const ProfileUrl=()=> {

    const myStyle={
        backgroundImage: `url(${LogoMark})`,
        backgroundColor: '#016b37',
        height:'200vh',
        marginTop:'-10px',
        fontSize:'50px',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
    };

  return (

    <div style={myStyle}>

<div className='header' >

<div className="logo">
        
    <svg width="39" height="39" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.338295 22.6568C0.606194 22.5996 0.829438 22.5551 1.04631 22.4979C1.9712 22.2818 2.37305 22.4534 2.66646 23.3623C3.20021 25.2568 4.00357 27.0653 5.05204 28.7328C8.24131 33.4486 12.7063 36.1625 18.447 36.3214C22.2925 36.4727 26.078 35.3362 29.1996 33.0933C32.3211 30.8504 34.5987 27.6304 35.6691 23.947C35.9051 23.1144 36.0263 22.2437 36.2176 21.2903H33.9213C33.4523 23.3762 32.6512 25.3738 31.5485 27.2074C30.529 28.8118 29.1972 30.1964 27.6316 31.2792C26.0661 32.3621 24.2986 33.1214 22.4336 33.5122C21.7957 33.6647 21.1579 33.7092 20.52 33.8935C19.8822 34.0778 19.7546 33.8236 19.7291 33.3406C19.6908 32.5334 19.7291 31.7263 19.6589 30.9191C19.6589 30.3662 19.576 29.8132 19.5313 29.3238C18.3832 29.095 17.2669 28.9743 16.2209 28.6883C14.7356 28.2086 13.3883 27.3791 12.2933 26.27C11.1984 25.1609 10.388 23.8051 9.93106 22.3174C9.47408 20.8298 9.38396 19.2543 9.66832 17.7246C9.95268 16.1948 10.6031 14.756 11.5645 13.5301C12.4235 12.5413 13.4151 11.6752 14.5114 10.9561C15.3917 10.3205 15.87 9.77397 15.6532 8.60453C15.5387 7.67789 15.584 6.73856 15.7871 5.82713C15.8524 5.63807 15.9615 5.46703 16.1056 5.32788C16.2497 5.18874 16.4247 5.08542 16.6163 5.02632C17.1844 4.96272 17.7578 4.96272 18.3258 5.02632V9.55152C20.3153 9.4286 22.3006 9.85061 24.0665 10.7718C24.5449 11.0324 24.985 11.3756 25.5208 11.7379C24.5002 12.7802 23.6072 13.7844 22.5867 14.7059C22.352 14.9086 22.1676 15.1627 22.0481 15.4483C21.9286 15.7339 21.8771 16.0433 21.8978 16.352C21.936 18.8498 21.8978 21.3475 21.8978 23.9406C21.2025 23.8326 20.4052 24.2966 19.6844 23.5847C18.1281 24.2775 16.5908 24.3093 15.3024 22.9492C14.1542 21.678 13.9501 19.3837 14.8048 17.7439C15.7616 15.9135 17.3563 15.5004 19.2698 15.9262V11.5472C18.4795 11.6497 17.6988 11.8154 16.9353 12.0429C15.455 12.5713 14.1674 13.5293 13.2386 14.7935C12.3098 16.0577 11.7822 17.5701 11.724 19.1358C11.6777 20.783 12.1847 22.3985 13.1646 23.726C14.1444 25.0536 15.5411 26.0171 17.133 26.4638C20.3223 27.4553 23.4733 26.1842 25.508 23.2352C25.9178 22.598 26.2946 21.9404 26.637 21.2649C27.3897 19.8794 27.0899 18.6464 26.0693 17.5215C25.5782 16.9812 25.0934 16.4347 24.5513 15.8245L27.8617 12.5831C28.6208 11.8523 28.6463 11.3438 27.8617 10.6066C26.1769 8.98658 24.0602 7.88349 21.7638 7.42874L21.0813 7.23172V4.81023C23.5789 5.05357 25.9348 6.07932 27.8107 7.74017C28.8631 8.68715 29.9666 9.57059 31.0446 10.4921C31.6378 11.0006 31.6251 11.5917 31.0446 12.1891C30.5294 12.6726 30.0458 13.1885 29.5967 13.7335C28.5634 15.119 28.5825 16.6698 28.9588 18.2841C29.5967 21.0552 28.7356 23.4513 26.9687 25.5804C26.0408 26.6979 24.8514 27.5709 23.5052 28.1226C22.1912 28.6883 21.8978 29.47 22.44 30.9255C24.0633 30.6998 25.5858 30.0086 26.822 28.9361C28.3762 27.7058 29.6126 26.123 30.4281 24.3198C31.2436 22.5166 31.6147 20.5452 31.5102 18.5701C31.4832 18.2435 31.4363 17.9188 31.3699 17.5977C31.102 15.9262 31.4784 15.1381 33.0857 14.1911C33.3218 15.1826 33.5641 16.1423 33.781 17.102C34.1701 18.818 34.1765 18.8244 36.0262 18.5447C36.2404 16.5879 35.9139 14.6101 35.0822 12.8247C32.7668 7.52408 28.8121 4.00942 23.1225 2.80821C16.8077 1.47989 11.3668 3.44377 6.85716 7.95626C4.81345 10.0176 3.4075 12.6208 2.80679 15.4559C2.66008 16.0914 2.60268 16.7969 2.50062 17.5024C2.72387 17.5596 2.88971 17.6041 3.05555 17.6359C4.46521 17.9028 4.64381 17.8329 4.96912 16.5109C5.73164 13.0134 7.73913 9.9091 10.6205 7.77195C11.3987 7.19994 12.2598 6.73598 13.1719 6.17033C13.363 6.76583 13.3735 7.40425 13.2022 8.00568C13.0309 8.60711 12.6853 9.14483 12.2088 9.55152C10.9581 10.6499 9.82511 11.8746 8.82814 13.206C6.57013 16.5999 6.6084 20.2925 7.98617 24.0105C9.36394 27.7286 12.196 30.0802 16.0678 31.1288C16.3548 31.2051 16.6482 31.3004 16.9353 31.4021C17.0813 31.4574 17.224 31.5211 17.3626 31.5928L17.0373 33.4995C15.6541 33.6851 14.2471 33.4362 13.0125 32.7877C9.91249 31.3004 7.8586 28.8154 6.44894 25.7965C5.78495 24.2734 5.2349 22.7035 4.80328 21.0997C4.6183 20.4641 4.34402 20.2226 3.73168 20.2162C2.76852 20.2162 1.81811 20.1527 0.842196 20.2162C0.146934 20.248 0.00022782 19.9684 0.00022782 19.3328C-0.0224388 14.7673 1.647 10.3541 4.68846 6.93936C7.53004 3.47669 11.5211 1.14117 15.9402 0.354942C18.739 -0.192679 21.6255 -0.1057 24.386 0.609434C27.1464 1.32457 29.7099 2.64952 31.8866 4.48609C35.4546 7.28746 37.8139 11.3411 38.482 15.8182C40.0766 26.0253 33.7108 36.1561 23.014 38.3043C16.9544 39.5119 11.4625 38.0056 6.66581 34.1223C3.63382 31.7364 1.50056 28.399 0.612572 24.6525C0.510516 24.2139 0.427594 23.769 0.35743 23.3178C0.334604 23.0982 0.328209 22.8773 0.338295 22.6568ZM19.6717 19.8095V19.1231C19.7078 18.8039 19.6213 18.483 19.4296 18.2247C19.2379 17.9665 18.9552 17.7902 18.6383 17.7312C18.4697 17.6717 18.2908 17.6467 18.1123 17.6576C17.9338 17.6684 17.7593 17.715 17.5992 17.7944C17.4391 17.8739 17.2966 17.9847 17.1804 18.1201C17.0641 18.2556 16.9764 18.4129 16.9225 18.5828C16.7208 19.2735 16.6601 19.9975 16.7439 20.712C16.7621 20.9084 16.8196 21.0991 16.9131 21.273C17.0066 21.4468 17.1341 21.6002 17.2882 21.7241C17.4422 21.8479 17.6196 21.9397 17.8099 21.994C18.0002 22.0484 18.1995 22.0641 18.396 22.0403C18.7877 21.9745 19.1389 21.7608 19.3766 21.4435C19.6142 21.1263 19.7199 20.7299 19.6717 20.337C19.678 20.159 19.6717 19.9811 19.6717 19.8095Z" fill="white"/>
    </svg>

  <p className="logoName">DIGITAL PLANET</p>

</div>

</div>

<div className='urlCont'>

    <h1>Claim your profile URL</h1>

    <p>Get your own, personal URL before it’s gone 👀</p>
    
    <img src={Flag} alt="Image Placeholder" />

    <input type="text" name='' placeholder='Your Unique url' className='uniqueUrl' required />

    <div class="line-1"></div>

    <div className='profileURLBtn'>
    <button className="previousBtn"> Previous </button>
    <button className="cUrlBtn"> Claim Your URL </button>
    </div>

    
    <div id='profileURLBtn1'>
    <button id="previousBtn1"> Previous </button>
    <button id="cUrlBtn1"> Claim Your URL </button>
    </div>

</div>

{/* Mobile Responsiveness */}

<div id='urlCont'>

    <h1>Claim your profile URL</h1>

    <p>Get your own, personal URL before it’s gone 👀</p>
    
    <img src={Flag} alt="Image Placeholder" />

    <input type="text" name='' placeholder='Your Unique url' id='uniqueUrl' required />

    <div class="line-1"></div>

    <div>
    <button id="previousBtn"> Previous </button>
    <button id="cUrlBtn"> Claim Your URL </button>
    </div>

</div>




</div>
  )
}

export default ProfileUrl